import * as Sentry from "@sentry/nextjs";
import { toast } from "sonner";

/**
 * Centralized fetcher with error handling, 401 redirect, and Sentry breadcrumbs.
 * Use with SWR: useSWR("/api/...", fetcher)
 * Use with React Query: useQuery({ queryFn: () => fetcher("/api/...") })
 * Use standalone: const data = await fetcher("/api/...");
 */
export const fetcher = async (...args: Parameters<typeof fetch>) => {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.toString();

    Sentry.addBreadcrumb({
        category: "fetch",
        message: url,
        level: "info",
    });

    const res = await fetch(...args);

    if (!res.ok) {
        if (res.status === 401) {
            // ponytail: next-intl has no imperative client API and this module is
            // not a component, so the 401 toast reads the locale off the URL and
            // keeps its own copy. Mirrors common.sessionExpired / .sessionExpiredDesc
            // and auth.login in messages/*.json — update both together.
            const az =
                typeof window !== "undefined" &&
                window.location.pathname.startsWith("/az");
            toast.error(
                az ? "Sessiyanızın vaxtı bitib" : "Oturumunuzun süresi dolmuş",
                {
                    description: az
                        ? "Davam etmək üçün zəhmət olmasa yenidən daxil olun"
                        : "Devam etmek için lütfen tekrar giriş yapın",
                    action: {
                        label: az ? "Daxil ol" : "Giriş Yap",
                        onClick: () => {
                            window.location.href = "/login";
                        },
                    },
                    duration: 10000,
                },
            );
            return null;
        }
        throw new Error(`HTTP error! status: ${res.status}`);
    }

    return res.json();
};
